var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aboutPage" }, [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "content-main" }, [_vm._m(0)])
      : _c("div", { staticClass: "phone-page" }, [
          _c("div", [_c("listTopImg", { attrs: { imgType: "5" } })], 1),
          _c("div", { staticClass: "banner-Box" }, [
            _c("div", { staticClass: "banner-map" }),
            _c("div", { staticClass: "banner-ewmList" }, [
              _c("div", { staticClass: "banner-ewmBox displayIB" }, [
                _c("img", {
                  staticClass: "banner-ewm",
                  attrs: { title: "", src: _vm.src1, alt: "" }
                }),
                _vm._m(1)
              ]),
              _c("div", { staticClass: "banner-ewmBox displayIB" }, [
                _c("img", {
                  staticClass: "banner-ewm",
                  attrs: { title: "", src: _vm.src2, alt: "" }
                }),
                _vm._m(2)
              ])
            ]),
            _vm._m(3)
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-bar" }, [
      _c("div", [
        _c("div", { staticClass: "content-bar-map" }),
        _c("div", { staticClass: "content-fotBox" }, [
          _c("div", { staticClass: "content-leftBox displayIB" }, [
            _c("div", { staticClass: "content-leftBox-fot" }, [
              _c("p", { staticClass: "font16px content-Tlt" }, [
                _vm._v("集团总部：")
              ]),
              _c("p", { staticClass: "font16px content-p" }, [
                _vm._v("Fax：400-8855-091")
              ]),
              _c("p", { staticClass: "font16px content-p" }, [
                _vm._v(
                  "Add：湖南省长沙市高新开发区汇智中路179号金荣同心工业园C6栋"
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "content-rightBox displayIB" }, [
            _c("div", { staticClass: "content-ewmBar displayIB" }, [
              _c("div", { staticClass: "content-ewmImg ZMLgzh" }),
              _c("p", { staticClass: "font16px content-p" }, [
                _vm._v("\n                扫码关注 "),
                _c("br"),
                _vm._v("\n                脂玫乐公众号\n              ")
              ])
            ]),
            _c("div", { staticClass: "content-ewmBar displayIB" }, [
              _c("div", { staticClass: "content-ewmImg ZMLApp" }),
              _c("p", { staticClass: "font16px content-p" }, [
                _vm._v("\n                扫码免费下载 "),
                _c("br"),
                _vm._v("\n                脂玫乐APP\n              ")
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "banner-ewmP" }, [
      _vm._v("\n            扫码免费下载 "),
      _c("br"),
      _vm._v("\n            脂玫乐APP\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "banner-ewmP" }, [
      _vm._v("\n            扫码关注 "),
      _c("br"),
      _vm._v("\n            脂玫乐公众号\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-content" }, [
      _c("p", { staticClass: "banner-tlt" }, [_vm._v("集团总部：")]),
      _c("p", { staticClass: "col666666 font22phone banner-text" }, [
        _vm._v("Fax：400-8855-091")
      ]),
      _c("p", { staticClass: "col666666 font22phone banner-text" }, [
        _vm._v("Add：湖南省长沙市高新开发区汇智中路179号金荣同心工业园C6栋")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d78ac754", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d78ac754","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/about/aboutPage/aboutPage.vue
// module id = 1206
// module chunks = 9